export default __webpack_public_path__ + "static/media/spinner.b31ebe75.svg";